var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "badger-accordion-item" }, [
    _c("dt", { staticClass: "badger-accordion__header" }, [
      _c("div", { staticClass: "js-badger-accordion-header" }, [
        _c(
          "button",
          { staticClass: "badger-accordion-toggle" },
          [
            _c(
              "span",
              { staticClass: "badger-accordion-title" },
              [_vm._t("header", [_vm._v("Collapse-Title")])],
              2
            ),
            _vm._v(" "),
            _vm.icon !== "" && _vm.iconComponent
              ? _c(_vm.iconComponent, {
                  tag: "component",
                  staticClass: "badger-toggle-indicator",
                  attrs: { opened: _vm.opened }
                })
              : _vm._e()
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "dd",
      { staticClass: "badger-accordion__panel js-badger-accordion-panel" },
      [
        _c(
          "div",
          { staticClass: "js-badger-accordion-panel-inner" },
          [_vm._t("content")],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25a8184a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25a8184a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-badger-accordion/src/BadgerAccordionItem.vue
// module id = null
// module chunks = 